import { FC } from "react";
import {
  getActualDescriptionApparel,
  lowerCaseFirstLetter,
  useIsMobile,
} from "../../../../utils";

import InfoIcon from "../../../../assets/icons/InfoIcon";

import { findBrandByDomain } from "../../../../configs/configLoader";
import { isLingerie } from "../../../../utils/categoryParams";
import { useTranslation } from "react-i18next";
import {
  SimilarProductType,
  RecommendedSizeType,
} from "../../../../types/result";

import { resultScreenUI } from "../../../../configs";
import { useMediaQuery } from "react-responsive";

import "./index.css";

interface IPropsDescriptionResults {
  isSizeUnavailable: boolean;
  selectedVariant: string;
  selectedSize: RecommendedSizeType | null;
  similarProducts: SimilarProductType[] | null;
  isSimilarProductsLoaded: boolean;
}

const DescriptionResults: FC<IPropsDescriptionResults> = ({
  isSizeUnavailable,
  selectedVariant,
  selectedSize,
  similarProducts,
  isSimilarProductsLoaded,
}) => {
  const isMobile = useIsMobile();

  const isLargeHeightRelative = useMediaQuery({
    maxHeight: !isMobile ? 830 : 778,
    minWidth: 767,
  });

  const { t } = useTranslation("components/results/result");

  const brandDefined = findBrandByDomain();

  const isDesktopGerardDarel =
    brandDefined?.name === "Gerard Darel" && !isMobile;
  const isPeserico = brandDefined?.name === "Peserico";
  const isSRP = brandDefined?.name === "SRP";
  const isLacoste = brandDefined?.name === "Lacoste";
  const isMolli = brandDefined?.name === "Molli";
  const isTDF = brandDefined?.name === "TDF";
  const isGivenchy = brandDefined?.name === "Givenchy";

  const isSRPUnavailable = isSRP && isSizeUnavailable;


  return isLacoste && isLingerie ? null : (
    <div
      className="result-body-text"
      style={{
        borderBottom:
          isSRP || isGivenchy
            ? "none"
            : isSizeUnavailable && similarProducts?.length
              ? "1px solid #E9E9E9"
              : "none",
        justifyContent: resultScreenUI.Description
          .textAlign as React.CSSProperties["justifyContent"],
        backgroundColor: isSRPUnavailable ? "#FDF4D5" : "transparent",
        paddingBottom: isDesktopGerardDarel
          ? "10px"
          : isSRPUnavailable
            ? "16px"
            : (isLargeHeightRelative &&
                  isSizeUnavailable &&
                  similarProducts?.length) ||
                (isMobile && isSizeUnavailable)
              ? "5px"
              : !isLargeHeightRelative &&
                  isSizeUnavailable &&
                  similarProducts?.length
                ? "25px"
                : 0,
        paddingTop: isPeserico ? "12px 16px" : isSRPUnavailable ? "16px" : "0",
        paddingLeft: isPeserico ? "12px 16px" : isSRPUnavailable ? "16px" : "0",
        paddingRight: isPeserico
          ? "12px 16px"
          : isSRPUnavailable
            ? "16px"
            : "0",
        margin: isGivenchy
          ? "30px 0"
          : isTDF
            ? "20px 0"
            : isSRP
              ? "32px 0"
              : "15px 0",
        borderRadius: isSRPUnavailable ? "4px" : 0,
        letterSpacing: (resultScreenUI.Description as any)?.letterSpacing,
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "10px",
        }}
      >
        {isSizeUnavailable ? (
          <p
            style={{
              color: isSRP
                ? "rgba(133, 100, 0, 1)"
                : (resultScreenUI.Description
                    .fontColor as React.CSSProperties["color"]),
              fontSize: isSRP
                ? "14px"
                : (resultScreenUI.Description
                    .fontSize as React.CSSProperties["fontSize"]),
              fontWeight: resultScreenUI.Description
                .fontWeight as React.CSSProperties["fontWeight"],
              textAlign: resultScreenUI.Description
                .textAlign as React.CSSProperties["textAlign"],
              display: "flex",
              alignItems: "center",
              lineHeight: "20px",
              letterSpacing: (resultScreenUI.Description as any)?.letterSpacing,
            }}
          >
            {t("unavailable.description")}
          </p>
        ) : (
          <div
            style={{
              color:
                isSRP &&
                !similarProducts?.length &&
                isSimilarProductsLoaded &&
                isSRPUnavailable
                  ? "rgba(133, 100, 0, 1)"
                  : (resultScreenUI.Description
                      .fontColor as React.CSSProperties["color"]),
              fontSize: isSRP
                ? "14px"
                : (resultScreenUI.Description
                    .fontSize as React.CSSProperties["fontSize"]),
              fontWeight: resultScreenUI.Description
                .fontWeight as React.CSSProperties["fontWeight"],
              textAlign: resultScreenUI.Description
                .textAlign as React.CSSProperties["textAlign"],
              lineHeight: "20px",
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              letterSpacing: (resultScreenUI.Description as any)?.letterSpacing,
            }}
          >
            <span
              style={{
                letterSpacing: (resultScreenUI.Description as any)
                  ?.letterSpacing,
              }}
              dangerouslySetInnerHTML={{
                __html: isMolli
                  ? lowerCaseFirstLetter(
                      t(
                        getActualDescriptionApparel(
                          selectedVariant,
                          selectedSize,
                        ),
                      ).replace("[S]", selectedSize?.label || ""),
                    )
                  : t(
                      getActualDescriptionApparel(
                        selectedVariant,
                        selectedSize,
                      ),
                    ).replace("[S]", selectedSize?.label || ""),
              }}
            />
          </div>
        )}
        {isSRPUnavailable ? (
          <InfoIcon
            style={{
              fontSize: "16px",
            }}
          />
        ) : null}
      </div>
    </div>
  );
};

export default DescriptionResults;
